<template>
  <div :class="['vericode', vcodeClass? '':'vericode-active']" @click='getVCode'><span>{{btnText}}</span></div>
</template>
<script>
const COMPONENT_NAME = 'vericode'
export default {
  name: COMPONENT_NAME,
  props: {
    time: {
      type: Number,
      default: 60
    },
    prefixText: {
      type: String,
      default: ''
    },
    suffixText: {
      type: String,
      default: 's后重新获取'
    },
    beginText: {
      type: String,
      default: '获取验证码'
    },
    endText: {
      type: String,
      default: '重新获取'
    },
    // 开始倒计时
    sendCode: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      vcodeTime: 0,
      scode: this.sendCode,
      svcode: null,
      text: this.beginText,
      clock: null,
      // 定时器用于关闭定时
      hasCountDown: false,
      createTiming: null,
      currentTiming: null
    }
  },
  watch: {
    sendCode: {
      handler (val, oldVal) {
        this.scode = val
      }
    },
    scode: {
      handler (val, oldVal) {
        this.calcTime(val)
      }
    }
  },
  computed: {
    btnText () {
      var text = this.beginText
      if (this.scode) {
        text = `${this.prefixText}${this.vcodeTime}${this.suffixText}`
      } else if (this.hasCountDown) {
        text = '重新获取'
      }
      return text
    },
    vcodeClass () {
      return this.checkVcodeDisable()
    }
  },
  methods: {
    checkVcodeDisable () {
      return this.disable || this.scode
    },
    getVCode () {
      if (!this.checkVcodeDisable()) {
        if (this.hasCountDown) {
          this.scode = true
        }
        this.$emit('send-code')
      }
    },
    calcTime (status) {
      var time = this.time
      var self = this
      var posTime = ''
      self.createTiming = +new Date()
      clearTimeout(this.clock)
      if (status) {
        var loop = function () {
          self.currentTiming = +new Date()
          if (self.hasCountDown) {
            posTime = time
            self.createTiming = +new Date()
            self.hasCountDown = false
          } else {
            posTime = time - Math.floor((self.currentTiming - self.createTiming) / 1000)
          }
          self.vcodeTime = posTime <= 0 ? 0 : posTime
          if (posTime > 0) {
            self.clock = setTimeout(function () {
              loop()
            }, 1000)
          } else {
            self.calcTimeEnd()
          }
        }
        loop()
      }
    },
    calcTimeEnd () {
      this.scode = false
      this.hasCountDown = true
      this.disable = false
      this.createTiming = null
      this.currentTiming = null
    }
  }
}
</script>
<style lang="less" scoped >
.vericode {
  position: relative;
  display: flex;
  height: 38px;
  line-height: 38px;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #ccc;
  background-color: #fff;
  text-align: center;
}
.vericode-active {
  color: #269cca;
}
</style>


// WEBPACK FOOTER //
// src/components/member/vericode/index.vue